import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

export const useAuthenticatedFetch = () => {
    const { instance } = useMsal();

    function getAccessToken() {
      let activeAccount = instance.getActiveAccount() || instance.getAllAccounts()[0];
      let tokenRequest = {
        scopes: [`${process.env.REACT_APP_API_AUTH_AUTHORITY}/.default`],
        account: activeAccount,
      };
  
      return instance.acquireTokenSilent(tokenRequest).then((response) => {
        instance.setActiveAccount(response.account);
        return response.accessToken;
      });
    }

    function authenticatedFetch(input, init) {
      return getAccessToken().then((token) => {
        let headers = new Headers(init?.headers || {});
        headers.append("Authorization", `Bearer ${token}`);
  
        let requestOptions = {
          ...init,
          headers,
          mode: "cors",
          withCredentials: true,
          credentials: "include",
        };
  
        let request = new Request(input, requestOptions);
  
        return fetch(request).then((response) => {
          if (!response.ok) {
            if (response.status === 401 || response.status === 403) {
              // If we receive a 401 or 403 response, the token may have expired or become invalid.
              // Clear the active account to force a re-login on the next interaction.
              instance.setActiveAccount(null);
            }
            throw Error(response.statusText);
          }
          return response;
        }).catch((error) => {
          if (error instanceof InteractionRequiredAuthError) {
            // If an interaction is required, clear the active account to force a re-login.
            instance.setActiveAccount(null);
          }
          throw error;
        });
      });
    }

    return authenticatedFetch;
}

export default useAuthenticatedFetch;